<template lang="html">
  <div>
    <div
      v-if="reschedulingInfo.receiver.id !== $store.state.userInfo.user_id"
      key="unauthorized"
    >
      <section class="section">
        <h1 class="section-description">授業振替情報を表示する権限がありません</h1>
      </section>
    </div>
    <div
      v-else-if="reschedulingInfo.status !== 'pending'"
      key="got-result"
    >
      <section class="section">
        <h1 class="section-description">指定された授業振替情報は承認または非承認しております</h1>
      </section>
    </div>
    <div
      v-else
      key="receiver-confirmation"
    >
      <section class="section" v-if="!reschedulingInfo.isDenying">
        <h1 class="section-description">以下の内容で授業振替を承認します</h1>
        <h1 class="section-description">よろしければ「振替を確定する」ボタンを押してください</h1>
        <!--振替内容の詳細-->
        <div class="info">
          <h1 class="info-caption">振替前の授業</h1>
          <div class="info-content">
            <div>
              <label
                v-if="reschedulingInfo.sender.user_type === 'teacher'"
                key="teacher-name"
              >
                先生のお名前：{{reschedulingInfo.sender.fullname}} 先生
              </label>
              <label
                v-if="reschedulingInfo.sender.user_type === 'student'"
                key="student-name"
              >
                生徒のお名前：{{reschedulingInfo.sender.fullname}} 様
              </label>
            </div>
            <div>
              <label>日付　　　　：{{ formattedDate(reschedulingInfo.target_reservation.date) }}</label>
            </div>
            <div>
              <label>時間　　　　：{{reschedulingInfo.target_reservation.start_time.slice(0, -2)}} 〜 {{reschedulingInfo.target_reservation.end_time.slice(0, -2)}}の１コマ</label>
            </div>
            <div>
              <label>座席　　　　：{{reschedulingInfo.target_reservation.classroom_name}}</label>
            </div>
          </div>
        </div>
        <p><i class="el-icon-back down-arrow"/></p>
        <div class="info">
          <h1 class="info-caption">振替後の授業</h1>
          <div class="info-content">
            <div>
              <label
                v-if="reschedulingInfo.sender.user_type === 'teacher'"
                key="teacher-name"
              >
                先生のお名前：{{reschedulingInfo.sender.fullname}} 先生
              </label>
              <label
                v-if="reschedulingInfo.sender.user_type === 'student'"
                key="student-name"
              >
                生徒のお名前：{{reschedulingInfo.sender.fullname}} 様
              </label>
            </div>
            <div>
              <label>日付　　　　：{{ formattedDate(reschedulingInfo.rescheduled_reservation.date) }}</label>
            </div>
            <div>
              <label>時間　　　　：{{reschedulingInfo.rescheduled_reservation.start_time}} 〜 {{reschedulingInfo.rescheduled_reservation.end_time}}の１コマ</label>
            </div>
            <div>
              <label>座席　　　　：{{reschedulingInfo.rescheduled_reservation.classroom_name}}</label>
            </div>
            <!--（講師のみ）授業のオプション-->
            <div v-if="reschedulingInfo.receiver.user_type === 'teacher'">
              <div>
                <label>授業の種類　　　　　　：{{ reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : reschedulingInfo.reservationOption.reservationType + '授業'}}</label>
              </div>
              <div>
                <label>配布物（確認テスト等）：{{ reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし' }}</label>
              </div>
              <div v-if="reschedulingInfo.reservationOption.reservationMessage">
                <label>連絡事項：</label>
                <div
                  v-for="row in reschedulingInfo.reservationOption.reservationMessage.split('\n')"
                  key="message-row"
                  class="message-row"
                >
                  <label>　{{ row }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--振替内容の詳細終了-->
        <!-- 編集ボタン -->
        <el-button
          class="btn btn-cancel"
          @click="cancelButtonClicked()"
        >
          戻って修正する
        </el-button>
        <el-button
          class="btn btn-ok"
          @click="confirmButtonClicked()"
        >
          振替を確定する
        </el-button>
        <!-- 編集ボタン 終わり -->
      </section>
      <section class="section" v-if="reschedulingInfo.isDenying">
        <h1 class="section-description">振替依頼を不承認し、他の振替候補日時を提案します</h1>
        <h1 class="section-description">よろしければ「完了」ボタンを押してください</h1>
        <div class="info" v-if="reschedulingInfo.receiver_message">
          <h1 class="info-caption">{{ senderDisplayName }}へのメッセージ</h1>
          <div class="info-content">
            <label>{{reschedulingInfo.receiver_message}}</label>
          </div>
        </div>
        <div class="info">
          <h1 class="info-caption">他の振替候補日時</h1>
          <div class="info-content">
            <ul id="candidate-list">
              <li
                v-for="(alternative_datetimes, index) in reschedulingInfo.alternative_datetimes"
                :key="'alternative_datetimes' + index"
              >
                <div class="alternative_datetimes-caption">
                  <i class="el-icon-caret-right"/>
                  <label>候補{{index+1}}</label>
                </div>
                <div class="alternative_datetimes-content">
                  <div>
                    <label>日付：{{formattedDate(alternative_datetimes.date)}}</label>
                  </div>
                  <div>
                    <label>時間：{{alternative_datetimes.start_time}} 〜 {{alternative_datetimes.end_time}}</label>
                    <label>{{alternative_datetimes.mode === 'slot' ? 'の1コマ' : 'の中で' + alternative_datetimes.duration + '分間' }}</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <el-button
          class="btn btn-cancel"
          @click="cancelButtonClicked()"
        >
          戻って修正する
        </el-button>
        <el-button
          class="btn btn-ok"
          @click="denyButtonClicked()"
        >
          完了
        </el-button>
      </section>
    </div>
  </div>
</template>

<script>

  import moment from 'moment'
  import {
    mapActions
  } from 'vuex'

  export default {
    data () {
      return {
        reschedulingInfo: this.$store.state.reschedulingInfo,
        receiverInfo: null
      }
    },
    name: 'reschedulingReceiverConfirmation',
    moundted () {

    },
    methods: {
      ...mapActions([
        'postReservation',
        'updateReschedulingInfo',
        'postReschedulings',
        'setReschedulingInfo',
        'editReservation',
        'sendMailReschedulingResult',
        'sendMailReschedulingRequest',
        'getReschedulingetList'
      ]),
      moment: moment,
      formattedDate (date) {
        moment.lang('ja', {
          weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
        })
        return moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）')
      },
      cancelButtonClicked () {
        this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash)
      },
      updateReservationDB (teacherId, studentId, reschedulingInfo) {
        // 予約情報がない場合は、reservation テーブルに新規に予約情報を作成する
        if (!reschedulingInfo.target_reservation.id) {
          return this.postReservation({
            student: studentId,
            teacher: teacherId,
            start_time: reschedulingInfo.rescheduled_reservation.start_time,
            end_time: reschedulingInfo.rescheduled_reservation.end_time,
            classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
            date: reschedulingInfo.rescheduled_reservation.date,
            has_test: reschedulingInfo.rescheduled_reservation.has_test,
            reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
            message: reschedulingInfo.rescheduled_reservation.reservation_message
          })
        } else {
          // 予約情報がある場合は、reservation テーブルの予約情報を更新する
          return this.editReservation({
            id: reschedulingInfo.target_reservation.id,
            reservation: {
              student: studentId,
              teacher: teacherId,
              start_time: reschedulingInfo.rescheduled_reservation.start_time,
              end_time: reschedulingInfo.rescheduled_reservation.end_time,
              classroom: reschedulingInfo.rescheduled_reservation.classroom_name,
              date: reschedulingInfo.rescheduled_reservation.date,
              has_test: reschedulingInfo.rescheduled_reservation.has_test,
              reservation_type: reschedulingInfo.rescheduled_reservation.reservation_type,
              message: reschedulingInfo.rescheduled_reservation.reservation_message
            }
          })
        }
      },
      confirmButtonClicked () {
        let teacherId
        let studentId
        let targetId
        if (this.reschedulingInfo.sender.user_type === 'teacher') {
          teacherId = this.reschedulingInfo.sender.id
          studentId = this.reschedulingInfo.receiver.id
        } else {
          teacherId = this.reschedulingInfo.receiver.id
          studentId = this.reschedulingInfo.sender.id
        }
        console.log(this.reschedulingInfo)
        this.updateReservationDB(teacherId, studentId, this.reschedulingInfo).then((res) => {
          if (res) {
            targetId = res.data.id
          } else {
            targetId = parseInt(this.reschedulingInfo.target_reservation.id)
          }
          this.updateReschedulingInfo({
            hash: this.reschedulingInfo.hash,
            reservation: {
              is_status: 'accepted',
              rescheduled_reservation: targetId,
              receiver_message: this.reschedulingInfo.receiver_message
            }
          }).then((res) => {
            this.sendMailReschedulingResult(this.reschedulingInfo.hash)
          }).then(() => {
            this.getReschedulingetList(this.$store.state.userInfo.user_id).then((res) => {
              if (res.data.length > 0) {
                console.log(res)
                this.reschedulinglist = true
              } else {
                this.reschedulinglist = false
              }
            })
            // 振替情報を承認に変更
            this.reschedulingInfo.status = 'accepted'
            // 変更した振替情報をstoreに保存
            console.log(this.reschedulingInfo)
            this.setReschedulingInfo(this.reschedulingInfo)
            console.log(this.reschedulingInfo)
            this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash + '/final_confirmation')
          })
        })
      },
      denyButtonClicked () {
        this.updateReschedulingInfo({
          hash: this.reschedulingInfo.hash,
          reservation: {
            is_status: 'denied',
            rescheduled_reservation: this.reschedulingInfo.target_reservation.id,
            receiver_message: this.reschedulingInfo.receiver_message,
            alternative_datetimes: this.reschedulingInfo.alternative_datetimes
          }
        }).then(() => {
          // 新たな振替依頼を送信
          let paramTargetReservation =
            this.reschedulingInfo.target_reservation.id
              ? {
                id: this.reschedulingInfo.target_reservation.id
              }
              : {
                date: this.reschedulingInfo.target_reservation.date,
                start_time: this.reschedulingInfo.target_reservation.startTime,
                end_time: this.reschedulingInfo.target_reservation.endTime
              }
          let paramCandidateDatetimes = this.reschedulingInfo.alternative_datetimes.map((cand) => {
            return {
              date: cand.date,
              start_time: cand.start_time,
              end_time: cand.end_time,
              mode: cand.mode,
              duration: cand.duration
            }
          })
          let paramReservationOption = {
            reservation_type: this.reschedulingInfo.rescheduled_reservation.reservation_type,
            has_test: this.reschedulingInfo.rescheduled_reservation.has_test,
            reservation_message: this.reschedulingInfo.rescheduled_reservation.reservation_message
          }
          console.log('------------------------')
          console.log(this.reschedulingInfo)
          console.log('------------------------')
          this.postReschedulings({
            sender: this.reschedulingInfo.receiver.id,
            receiver: this.reschedulingInfo.sender.id,
            target_reservation: paramTargetReservation,
            candidate_datetimes: paramCandidateDatetimes,
            reason: '依頼の日程の都合が悪いため代替の日程を提案します',
            reservation_option: paramReservationOption,
            school_id: this.$store.state.userInfo.school_id
          })
          .then((res) => {
            this.getReschedulingetList(this.$store.state.userInfo.user_id).then((res) => {
              if (res.data.length > 0) {
                console.log(res)
                this.reschedulinglist = true
              } else {
                this.reschedulinglist = false
              }
            })
            // 振替情報を拒否に変更
            this.reschedulingInfo.status = 'denied'
            // 変更した振替情報をstoreに保存
            this.setReschedulingInfo(this.reschedulingInfo)
            // 結果メールの送信
            this.sendMailReschedulingResult({
              hash: this.reschedulingInfo.hash,
              newhash: res.data.hash
            })
            .then(() => {
              this.$router.push('/rescheduling/' + this.$route.params.rescheduling_hash + '/final_confirmation')
            })
            .catch((err) => {
              console.log(err)
            })
          })
          .catch((err) => {
            console.log(err)
          })
        })
      }
    },
    computed: {
      senderDisplayName () {
        return this.reschedulingInfo.sender.fullname +
          (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様')
      }
    }
  }

</script>


<style lang="css" scoped>
  .section {
    border-bottom: solid 2px black;
    text-align: center;
    margin: 10px 5% 10px 5%;
    padding-bottom: 20px;
  }
  .section-description {
    font-size: 18px;
    margin-bottom: 5px;
  }
  .info {
    max-width: 500px;
    margin: 10px auto;
    border: solid 1px #0065b3;
  }
  .info-caption {
    text-align: left;
    font-size: 18px;
    color: white;
    background-color: #0065b3;
    padding-left: 10px;
  }
  .info-content {
    text-align: left;
    padding: 10px 10px 10px 30px;
  }
  .btn {
    color: black;
  }
  .btn-ok {
    color: white;
    background-color: #0065b3;
  }
  .alternative_datetimes-caption {
    font-size: 18px;
    font-weight: bold;
    color: #0065b3;
  }
  .alternative_datetimes-content {
    padding-left: 30px;
  }
  .down-arrow {
    transform: rotate(270deg);
    font-size: 32px;
    font-weight: bold;
    color: #0065b3;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingReceiverConfirmation.vue?61d15068